<template>
    <div>
        <b-card>
            <app-sub-title text="Estado de herramientas"/>
            <b-card-body>
                <div class="card-text flex-row">
                    <div class="p-2">
                        <strong>Turno: </strong> {{shift.id}}
                    </div>
                    <div class="p-2">
                        <strong>Punto de acceso: </strong> {{shift.structure.name}}
                    </div>
                    <div class="p-2">
                        <strong>Vigilante: </strong> {{shift.user.name}}
                    </div>
                    <div class="p-2 bg-warning">
                        <strong>Inicio del turno: </strong> {{shift.start_time | datetime}}
                    </div>
                    <div class="p-2">
                        <strong>Fin del turno: </strong> 
                        <div v-if="shift.end_time">{{shift.end_time | datetime}}</div>
                        <div v-if="!shift.end_time">Sin finalizar</div>
                    </div>   
                    <div class="p-2">
                        <strong>Notas de Inicio:</strong> {{ shift.notes }}
                    </div>
                    <div class="p-2" v-if="!!shift.close_shift">
                        <strong>Notas de fin:</strong> {{ shift.close_shift.notes }}
                    </div>
                </div>
            </b-card-body>
            <b-list-group flush v-if="shift.shift_tool_statuses.length">
                <strong>Herramientas</strong>
                <b-list-group-item v-for="(shiftToolStatuses, i) in shift.shift_tool_statuses" :key="i" :variant="itemVariant(shiftToolStatuses.tool_status.name)" :class="{border: shiftToolStatuses.user.profile.slug === 'supervisor', 'border-danger': shiftToolStatuses.user.profile.slug === 'supervisor'}">
                    <div class="alert alert-danger w-100 py-1 px-2" v-if="shiftToolStatuses.user.profile.slug === 'supervisor'"><small>Supervisión por: {{shiftToolStatuses.user.name}}</small></div>
                    <div><strong>Nombre:</strong>  {{shiftToolStatuses.tool.name}}</div>
                    <div><strong>Estado:</strong> {{shiftToolStatuses.tool_status.name}}</div>
                    <div ><strong>Notas:</strong> <span v-if="shiftToolStatuses.notes">{{shiftToolStatuses.notes}}</span></div>
                </b-list-group-item>
            </b-list-group>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        shift: {
            required: true,
            type: Object
        }
    },
    methods:{
        itemVariant(name){
            return ['Regular', 'Malo'].includes(name)?'danger':'';
        }
    }
}
</script>